<template>
    <div>
        <div class="container text-center">
            <div class="pt-5 pb-5 gold-spinner mx-auto spinner-border" role="status" aria-label="Loading...">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import digitalApi from '@/services/DigitalApiClient.js'

    const route = useRoute()
    const router = useRouter()

    onMounted(async () => {
        try {
            const response = await digitalApi.verify(route.query.regToken, window.gigya.apiKey)
            if (response.data.errorCode == 0 || response.data.errorCode == 403101) {
                router.push({ name: 'GetRewardsHome', params: { showVerifiedMessage: true } })
            } else if (response.data.errorCode == 403002) {
                // link expired
                router.push({ name: 'GetRewardsHome', params: { showVerifiedErrorMessage: true } })
            } else {
                // unknown error code
                router.push({ name: 'GetRewardsHome', params: { showVerifiedErrorMessage: true } })
            }
        } catch (error) {
            router.push({ name: 'GetRewardsHome', params: { showVerifiedErrorMessage: true } })
        }
    })
</script>

<style lang="scss" scoped>
.container {
  height: 60vh;
}
</style>
